var typographyStyles = {
    fontSize: {
        h1: '6rem',
        h2: '3.75rem',
        h3: '3rem',
        h4: '2.125rem',
        h5: '1.5rem',
        h6: '1.25rem',
        subtitle1: '1rem',
        subtitle2: '0.875rem',
        body1: '1rem',
        body2: '0.875rem',
        button: '14px',
        caption: '0.75rem',
        overline: '0.75rem',
    },
    letterSpacing: {
        h1: '-1.5px',
        h2: '-.5px',
        h3: '0',
        h4: '.25px',
        h5: '0',
        h6: '.15px',
        subtitle1: '.15px',
        subtitle2: '.1px',
        body1: '.15px',
        body2: '.17px',
        button: '.4px',
        caption: '.4px',
        overline: '1px',
    },
    fontWeight: {
        h1: 400,
        h2: 400,
        h3: 400,
        h4: 400,
        h5: 400,
        h6: 600,
        subtitle1: 400,
        subtitle2: 400,
        body1: 400,
        body2: 400,
        button: 600,
        caption: 400,
        overline: 400,
    },
    textTransform: {
        button: 'capitalize',
    },
};
export var typographyOptions = {
    typography: {
        fontFamily: "'sohne', Fallback, sans-serif",
        h1: {
            fontSize: typographyStyles.fontSize.h1,
            fontWeight: typographyStyles.fontWeight.h1,
            letterSpacing: typographyStyles.letterSpacing.h1,
        },
        h2: {
            fontSize: typographyStyles.fontSize.h2,
            fontWeight: typographyStyles.fontWeight.h2,
            letterSpacing: typographyStyles.letterSpacing.h2,
        },
        h3: {
            fontSize: typographyStyles.fontSize.h3,
            fontWeight: typographyStyles.fontWeight.h3,
            letterSpacing: typographyStyles.letterSpacing.h3,
        },
        h4: {
            fontSize: typographyStyles.fontSize.h4,
            fontWeight: typographyStyles.fontWeight.h4,
            letterSpacing: typographyStyles.letterSpacing.h4,
        },
        h5: {
            fontSize: typographyStyles.fontSize.h5,
            fontWeight: typographyStyles.fontWeight.h5,
            letterSpacing: typographyStyles.letterSpacing.h5,
        },
        h6: {
            fontSize: typographyStyles.fontSize.h6,
            fontWeight: typographyStyles.fontWeight.h6,
            letterSpacing: typographyStyles.letterSpacing.h6,
        },
        subtitle1: {
            fontSize: typographyStyles.fontSize.subtitle1,
            fontWeight: typographyStyles.fontWeight.subtitle1,
            letterSpacing: typographyStyles.letterSpacing.subtitle1,
        },
        subtitle2: {
            fontSize: typographyStyles.fontSize.subtitle2,
            fontWeight: typographyStyles.fontWeight.subtitle2,
            letterSpacing: typographyStyles.letterSpacing.subtitle2,
        },
        body1: {
            fontSize: typographyStyles.fontSize.body1,
            fontWeight: typographyStyles.fontWeight.body1,
            letterSpacing: typographyStyles.letterSpacing.body1,
        },
        body2: {
            fontSize: typographyStyles.fontSize.body2,
            fontWeight: typographyStyles.fontWeight.body2,
            letterSpacing: typographyStyles.letterSpacing.body2,
        },
        button: {
            fontSize: typographyStyles.fontSize.button,
            fontWeight: typographyStyles.fontWeight.button,
            letterSpacing: typographyStyles.letterSpacing.button,
            textTransform: typographyStyles.textTransform.button,
        },
        caption: {
            fontSize: typographyStyles.fontSize.caption,
            fontWeight: typographyStyles.fontWeight.caption,
            letterSpacing: typographyStyles.letterSpacing.caption,
        },
        overline: {
            fontSize: typographyStyles.fontSize.overline,
            fontWeight: typographyStyles.fontWeight.overline,
            letterSpacing: typographyStyles.letterSpacing.overline,
        },
    },
};
